import { isObject } from 'lodash';
import { Parameter, Parameters } from './interfaces/settings.interface';

export function isParameter(parameter: Parameters | Parameter): parameter is Parameter {
  return Object.keys(parameter).every((key) => parameter[key].hasOwnProperty('checked'));
}

export function showParameter(parameters: Parameters | Parameter, param: string): boolean {
  return isParameter(parameters)
    ? Object.keys(parameters).some(
        (parameter) => parameter === param && parameters[parameter].checked
      )
    : Object.keys(parameters).some((type) => showParameter(parameters[type], param));
}

export function findValueInObject(object: Object, key: string) {
  if (!object) {
    return null;
  }
  let value;

  Object.keys(object).some((k) => {
    if (k === key) {
      value = object[k];
      return true;
    }
    if (isObject(object[k])) {
      value = findValueInObject(object[k], key);
      return value !== undefined;
    }
  });
  return value;
}
